<template>
  <button type="button" :class="classes" @click="passClick"></button>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  methods: {
    passClick() {
      this.$emit('click');
    },
  },
};
</script>
